import {createAction} from 'web-app/util/redux/typed-action-helpers';

const domain = 'MODALS/DISABLE_FAMLY_PAY_MODAL';

export const {action: show} = createAction(
    `${domain}/SHOW`,
    (payload: {paymentsAccountId: string; institutionId: string}) => payload,
);

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));
